export default __webpack_public_path__ + "static/media/logo-big-shop2.946b5267.png";